module.exports = __webpack_public_path__ + "img/pr-15.5d79f3b4.png";